export function SpecialChapterView({ chapter, onClose }) {
  if (!chapter) return null;
  const isBP = chapter.chapter_type === 'blueprints';
  const color = isBP ? '#3b82f6' : '#ef4444';
  const lightColor = isBP ? '#93c5fd' : '#fca5a5';

  return (
    <div className="max-w-4xl mx-auto px-4 py-8 fade-up" data-testid="special-chapter-view">
      {/* Back button */}
      <button onClick={onClose} data-testid="special-back-btn"
        className="flex items-center gap-2 mb-8 text-sm transition-colors hover:text-amber-300"
        style={{ color: 'rgba(217,119,6,0.5)' }}>
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
        Back to Treasure Map
      </button>

      {/* Chapter card */}
      <div className="rounded-2xl border overflow-hidden"
        style={{ background: 'linear-gradient(180deg, #0f0a04, #080604)', borderColor: `${color}30` }}>

        {/* Header */}
        <div className="px-8 py-6 border-b" style={{ borderColor: `${color}15` }}>
          <div className="flex items-center gap-3 mb-3">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center"
              style={{ background: `${color}12`, border: `1.5px solid ${color}30` }}>
              {isBP ? (
                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke={color} strokeWidth={1.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 14l2 2 4-4" />
                </svg>
              ) : (
                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke={color} strokeWidth={1.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
              )}
            </div>
            <div>
              <span className="text-[8px] tracking-[0.3em] uppercase font-mono px-2 py-0.5 rounded-full"
                style={{ background: `${color}15`, color: color, border: `1px solid ${color}30` }}>
                Prerequisite Chapter
              </span>
            </div>
          </div>

          <h1 className="text-2xl sm:text-3xl font-serif font-bold mb-2" style={{ color: lightColor }}>
            {chapter.title}
          </h1>
        </div>

        {/* Summary */}
        {chapter.laymen_summary && (
          <div className="px-8 py-5 border-b" style={{ borderColor: `${color}10`, background: `${color}05` }}>
            <p className="text-[9px] tracking-[0.2em] uppercase font-mono mb-2" style={{ color: `${color}80` }}>Summary</p>
            <p className="text-sm font-serif leading-relaxed" style={{ color: 'rgba(252,211,77,0.7)' }}>
              {chapter.laymen_summary}
            </p>
          </div>
        )}

        {/* Full Content */}
        <div className="px-8 py-6">
          <p className="text-[9px] tracking-[0.2em] uppercase font-mono mb-4" style={{ color: `${color}60` }}>Full Chapter</p>
          <div className="text-sm font-serif leading-loose whitespace-pre-wrap" style={{ color: 'rgba(245,230,200,0.65)' }}>
            {chapter.content || 'Full content will be available here once the chapter is uploaded.'}
          </div>
        </div>
      </div>
    </div>
  );
}
